// Mounting details for Paddle's *inline* checkout, shared by every checkout route. Paddle finds
// the mount point by class name, so the class and the element that carries it must agree -- which
// is why these live beside each other rather than in the component and the hook separately.

/** Class Paddle looks for when mounting the inline checkout iframe. */
export const PADDLE_FRAME_CLASS = 'inline-checkout-paddle-frame';

export const PADDLE_FRAME_STYLE =
  'width: 100%; min-width: 312px; background-color: transparent; border: none;';

/** Paddle requires at least this much room before it has measured the form. */
export const PADDLE_FRAME_INITIAL_HEIGHT = 450;

/**
 * How long to wait for Paddle's first event before giving up. A frame that is blocked outright
 * (an extension, a locked-down network) reports nothing at all, so without this the buyer would
 * watch the spinner forever instead of being offered the retry.
 */
export const PADDLE_LOAD_TIMEOUT_MS = 30000;
